import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ breakpoints, custom }: Theme) => ({
  root: {
    width: '100%',
  },
  label: {
    display: 'block',
    width: '100%',
  },
  subLabel: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    color: custom.grey[2],
    fontSize: 12,
    '& > span': {
      flexBasis: 0,
      flexGrow: 1,
      '&:not(:last-child)': {
        paddingRight: 10,
      },
      [breakpoints.down(450)]: {
        flexBasis: '20%',
        flexGrow: 0,
        '&:first-child': {
          flexBasis: '25%',
          maxWidth: 60,
        },
        '&:nth-child(3)': {
          flexBasis: '35%',
          maxWidth: 90,
        },
      },
    },
  },
}));
